import React, { useEffect,useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './Lobby.scss';
import '../../style/css/breadcrumb.scss';
import {
    CardDashboard,
    CardWorkInformation,
    CardDocumentDownload,
    CardLawInfo,
    CardOtherFunctions
} from './Components/';

import {
    ImgDashboard,
    ImgMonitor,
    ImgDisaster,
    ImgMapSystem
} from '../../style/images/system-icons/index'
import axios from "Uitilities/axios";

const Lobby = () => {
    const [Dashboard,setDashboard] = useState([])
    const [WorkInformation, setWorkInformation] = useState([])
    const [Document, setDocument] = useState([])
    const [OtherFunctions, setOtherFunctions] = useState([])
    useEffect(()=>{
        axios.get('GetDataTransfer/GetLobbyFunc')
        .then(res=>{
            res.data.forEach(item=>{
                if (item.first=='一'){
                    setDashboard(prevArray =>[...prevArray,item])
                }else if (item.first=='二'){
                    setWorkInformation(prevArray=>[...prevArray,item])
                }else if (item.first=='三'){
                    setDocument(prevArray=>[...prevArray,item])
                }else if (item.first=='四'){
                    setOtherFunctions(prevArray=>[...prevArray,item])
                }else{throw Error("無此功能")}
            })
        })
        .catch(err=>console.log(err))
    },[])
    return (
        <>
            <Container className="lobby-page l-system-switch-panel mt-5">
                <Row className='mt-5'>
                    <Col className="col-lg-4 col-12 px-4 lobby-block"><CardDashboard func={Dashboard}/></Col>
                    <Col className="col-lg-8 col-12 px-4 lobby-block"><CardWorkInformation func={WorkInformation}/></Col>
                </Row>
                <Row>
                    {/* <Col className="col-6 px-4">
                        <Row>
                            {Document.length>0?<CardDocumentDownload func={Document}/>:<></>}
                        </Row>
                        {<Row>
                        <CardLawInfo />
                    </Row> }
                    </Col> */}
                    <Col className="col-12 px-4 lobby-block">
                        <CardOtherFunctions func={OtherFunctions}/>
                    </Col>
                </Row>
            </Container>
            <Container className="m-lobby-page l-system-switch-panel">
                <div className="m-lobby-part">
                <button className="m-lobby-btn btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                <img src={ImgDashboard} width="30" alt="" />
                <span>儀錶板</span> 
                </button>

                <div className="collapse" id="collapseExample">
                    <div className="card card-body">
                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/CarBridge/">車行橋</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/Underpass/">地下道</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/ManBridge/">人行橋</a>
                            </div>
                        </nav>
                       {/*   <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/DetailTestAnalyze/">詳檢分析</a>
                            </div>
                        </nav>*/}
                    </div>
                </div>
                </div>
                

                {/* <div className="m-lobby-part">
                <button className="m-lobby-btn btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample2">
                    <img src={ImgMonitor} width="30" alt="" />
                    <span>監測</span> 
                </button>

                <div className="collapse" id="collapseExample2">
                    <div className="card card-body">
                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">車行橋監測列表</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">地下道監測列表</a>
                            </div>
                        </nav>
                    </div>
                </div>
                </div>

                <div className="m-lobby-part">
                <button className="m-lobby-btn btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample3">
                    <img src={ImgMapSystem} width="30" alt="" />
                    <span>地圖查詢</span> 
                </button>

                <div className="collapse" id="collapseExample3">
                <div className="card card-body">
                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">車行橋</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">地下道</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="#">人行橋</a>
                            </div>
                        </nav>
                    </div>
                </div>
                </div>*/}

                <div className="m-lobby-part">
                <button className="m-lobby-btn btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample4">
                    <img src={ImgDisaster} width="30" alt="" />
                    <span>防災資訊</span> 
                </button>

                <div className="collapse" id="collapseExample4">
                <div className="card card-body">
                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/DisasterPrevention/floodprevention">防災水位資訊</a>
                            </div>
                        </nav>

                        <nav className="navbar ">
                            <div className="container-fluid">
                                <a className="navbar-brand" href="./Dashboard/DisasterPrevention/basic">地震資訊</a>
                            </div>
                        </nav>

                    </div>
                </div>
                </div> 
                <div className="m-lobby-part">
        {/* 新增的橋梁詳檢按鈕 */}
       {/*  <button className="m-lobby-btn btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBridgeInspection" aria-expanded="false" aria-controls="collapseBridgeInspection">
            <img src={ImgDisaster} width="30" alt="" />
            <span>橋梁詳檢</span> 
        </button>

        {/* 橋梁詳檢內容 */}
        {/* <div className="collapse" id="collapseBridgeInspection">
            <div className="card card-body">
                <nav className="navbar ">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="./Dashboard/DetailTestAnalyze">橋梁詳檢列表</a>
                    </div>
                </nav>
            </div>
        </div>*/}
    </div>
                
                
            </Container>
        </>

    )
}

export default Lobby;